import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: () => import(/* webpackChunkName: "home" */ './views/init/index.vue')
  // }, {
  //   path: '/live',
  //   name: 'live',
  //   component: () => import(/* webpackChunkName: "home" */ './views/init/index.vue')
  // }
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ './views/home/index.vue')
  }, {
    path: '/page',
    name: 'page',
    component: () => import(/* webpackChunkName: "page" */ './views/page/index.vue')
  }, {
    path: '/live',
    name: 'live',
    component: () => import(/* webpackChunkName: "live" */ './views/live/index.vue')
  }
]
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
export default router
